(() => {
    function customAddToCart() {
        if (!!window._cpb.settings === false) window._cpb.settings = {}
        window._cpb.settings.addToCartOverride = async data => {

            const addToCartItems = data.items.filter(item => !item.configid)

            fetch("/cart/add.js", {
                "headers": {
                    "content-type": "application/json;charset=UTF-8"
                },
                "body": JSON.stringify({
                    items: addToCartItems
                }),
                "method": "POST"
            }).then(() => {
                if(data.redirect) location.href = '/cart'
            })
        }
    }

    document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
        customAddToCart()
    })
})()